import { Component, OnInit } from "@angular/core";
import { AggregateHelperService, AggregateService } from "@tylertech/aggregates-module";
import { IAggregate } from "@tylertech/tyler-api-types";
import { IWidget } from "./iWidget";
import { NavigationService } from "@tylertech/core-module";
@Component({
    selector: "widget-bar",
    templateUrl: "./widgetBar.tmpl.html",
    styleUrls: ["./widgetBar.component.scss"],
    standalone: false
})
export class WidgetBarComponent implements OnInit
{
    private readonly pageSize: number = 4;

    private page: number = 0;

    private readonly pages: IWidget[][] = [];

    private _loaded: boolean;

    constructor(
        private $aggregateService: AggregateService,
        private $aggregateHelperService: AggregateHelperService,
        private readonly $navigationService: NavigationService,
    ) { }

    ngOnInit(): void
    {
        this.fetchTileAggregates()
            .then(widgets =>
            {
                let index = 0;
                let pageIndex = 0;
                for (const widget of widgets)
                {
                    if (!this.pages[pageIndex]) this.pages[pageIndex] = [];
                    this.pages[pageIndex].push(widget);
                    index++;
                    if (index >= this.pageSize)
                    {
                        index = 0;
                        pageIndex++;
                    }
                }
                this._loaded = true;
            });
    }

    get hasPreviousPage(): boolean
    {
        return this.page > 0;
    }

    get hasNextPage(): boolean
    {
        return this.page + 1 < this.pages.length;
    }

    get widgetsLoaded(): boolean
    {
        return this._loaded;
    }

    get shownWidgets(): IWidget[]
    {
        return this.pages[this.page];
    }

    goToPreviousPage(): void
    {
        this.page = this.page - 1;
    }

    goToNextPage(): void
    {
        this.page = this.page + 1;
    }

    private fetchTileAggregates(): Promise<IWidget[]>
    {
        const self = this;
        return this.$aggregateService
            .GetWidgetAggregates()
            .then(x => x.Result)
            .then(onSuccess);
        function onSuccess(result: WidgetAggregate[]): Array<IWidget>
        {
            return !result ? [] : result.filter(x => !!x)
                .map(x => self.convertToWidget(x));
        }
    }

    private convertToWidget(x: WidgetAggregate): IWidget
    {
        const widget = <IWidget>{
            title: x.Name,
            count: x.Count,
            icon: x.Icon,
            color: x.Color,
            url: x.Url,
            textAlign: x.TextAlign,
            metadataAction: x.MetadataAction,
            secondaryText: x.SecondaryText
        };
        if (x.Url && x.Url.substr(0, 1) === "/")
        {
            widget.url = this.$navigationService.getLinkToApp(x.Url) as string;
        }
        const intent = this.$aggregateHelperService.getDataElementByLabel("intent", x.AggregateCardDataElements);
        if (intent)
        {
            widget.mime = intent.Type;
            widget.action = intent.Value;
        }
        return widget;
    }
}
interface WidgetAggregate extends IAggregate
{
    Url: string;
    Icon: string;
    Color: string;
    ClickEvent: string;
    TextAlign: string;
    MetadataAction: any;
    SecondaryText: string;
}
